import { Reducer } from 'redux';
import {
    SurveyState,
    SurveyActions,
    ToggleSurveySentAction,
    ChangeTypeOfFinalTransactionCompletedAction
} from './type';
import {
    toggleSurveySentStatusHandler,
    changeTypeFinalOfTransactionCompletedHandler
} from './handlers';
import {
    TOGGLE_SURVEY_SENT_STATUS,
    CHANGE_TYPE_OF_FINAL_TRANSACTION_COMPLETED
} from './constant';
import { TypeOfFinalTransaction, ErrorCodes } from '../../dtos/KioskDtos.dtos';

export const initialState: SurveyState = {
    surveySent: false,
    typeOfFinalTransactionCompleted: TypeOfFinalTransaction.None,
    errorCode: ErrorCodes.None
};

const reducer: Reducer<SurveyState> = (state: SurveyState = initialState, action: SurveyActions) => {
    switch (action.type) {
        case TOGGLE_SURVEY_SENT_STATUS:
            return toggleSurveySentStatusHandler(state, action as ToggleSurveySentAction);

        case CHANGE_TYPE_OF_FINAL_TRANSACTION_COMPLETED:
            return changeTypeFinalOfTransactionCompletedHandler(state, action as ChangeTypeOfFinalTransactionCompletedAction);

        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/Survey/reducer.ts